<script setup lang="ts">
  import { storeToRefs } from "pinia";
  import { ClipboardCopy, X } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import { toast } from "@/components/ui/sonner";
  import { useMAssetLibraryStore } from "@stores/mAssetLibrary";
  import ImageLibraryAssetThumbnail from "@/components/MCampaign/ImageLibrary/ImageLibraryAssetThumbnail.vue";

  const assetLibraryStore = useMAssetLibraryStore();
  const { selectedIds, selectedAssets } = storeToRefs(assetLibraryStore);
  const { toggleSelection, clearSelection, copySelectionForClaude } = assetLibraryStore;

  const copyForClaude = async () => {
    const count = selectedIds.value.length;
    if (await copySelectionForClaude()) toast.success(`${count} image${count > 1 ? "s" : ""} copied to clipboard`);
  };
</script>

<template>
  <div class="flex items-center gap-3 border-t bg-muted/40 px-6 py-3">
    <span class="text-sm font-medium">{{ selectedIds.length }} selected</span>

    <div class="flex flex-1 gap-2 overflow-x-auto">
      <div
        v-for="image in selectedAssets"
        :key="image.id"
        class="group relative h-14 w-14 shrink-0 overflow-hidden rounded border bg-background">
        <ImageLibraryAssetThumbnail :asset="image" />
        <button
          type="button"
          class="absolute right-0 top-0 hidden h-5 w-5 items-center justify-center rounded-bl bg-black/60 text-white group-hover:flex"
          @click="toggleSelection(image.id)">
          <X class="h-3 w-3" />
        </button>
      </div>
    </div>

    <Button
      variant="outline"
      size="sm"
      @click="copyForClaude">
      <ClipboardCopy class="mr-1 h-4 w-4" />
      Copy to clipboard
    </Button>
    <slot name="actions" />

    <Button
      variant="outline"
      size="sm"
      @click="clearSelection">
      Clear
    </Button>
  </div>
</template>
